import React from 'react';
interface AvatarProps{
  setDanPos?:Function
  src:string,
  width?:number
}
const Avatar:React.FunctionComponent<AvatarProps> = ({setDanPos, src, width=40}:AvatarProps) => {
  return <img src={src} alt="profile" width={width} id="danface"
        {
          ...(
            !!setDanPos ? {
              onDragEnd:e=>{e.persist();setDanPos(e)},
              draggable:true
            }:{}
          )
        }
      />
}
export default Avatar;
